// ReusableDrawer.tsx
import React from 'react';
import { Drawer } from 'antd';
import { IReusableDrawerProps } from '@/ts/common-types';

const CustomDrawer = ({
    title,
    width,
    onClose,
    open,
    children,
    footer
}: IReusableDrawerProps) => {
    return (
        <Drawer title={title} width={width} onClose={onClose} open={open} footer={footer}>
            {children}
        </Drawer>
    );
};

export default CustomDrawer;